import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let _cache = null;
let _inflight = null;
const _subscribers = new Set();

async function _fetchSettings() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = fetch(`${BACKEND_URL}/api/site-settings`)
    .then((r) => (r.ok ? r.json() : {}))
    .catch(() => ({}))
    .then((data) => {
      _cache = data || {};
      _inflight = null;
      _subscribers.forEach((cb) => cb(_cache));
      return _cache;
    });
  return _inflight;
}

/**
 * Hook that returns all site settings as a flat object.
 * `get(key, fallback)` is a helper so consumers don't need to null-check.
 */
export function useSiteSettings() {
  const [settings, setSettings] = useState(_cache || {});

  useEffect(() => {
    let mounted = true;
    const update = (data) => {
      if (mounted) setSettings(data);
    };
    _subscribers.add(update);
    _fetchSettings().then(update);
    return () => {
      mounted = false;
      _subscribers.delete(update);
    };
  }, []);

  const get = (key, fallback = '') => {
    const v = settings[key];
    if (v === undefined || v === null || v === '') return fallback;
    return v;
  };

  return { settings, get };
}
